import React, { useEffect, useState } from "react";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";

import axios from "axios";
import LoadingSpinner from "../../components/LoadingSpinner";
import RefundModal from "./modals/RefundModal";
import OnePaymentModal from "./modals/OnePaymentModal";
import { useNavigate } from "react-router-dom";

export default function PaymentsMade() {
  const [payments, setPayments] = useState([]);
  const { user, dispatch } = useAuthContext();
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [noMorePayments, setNoMorePayments] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [refundModal, setRefundModal] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [onePaymentModal, setOnePaymentModal] = useState(false);
const navi = useNavigate();
  const cancelModal = () => {
    setRefundModal(false);
    setOnePaymentModal(false)
  };

  const refundFromOnePayment = () => {
    setOnePaymentModal(false)
    setRefundModal(true);
  }

  const fetchData = async () => {
    setIsLoading(true);
    try {
      // Fetch payment data
      const paymentResponse = await axios.get(
        `${ApiConnectionString}/api/MyPayments?Skip=0&Take=10`,
        {
          headers: { Authorization: `Bearer ${user?.token}` },
        }
      );
      setPayments(paymentResponse.data);
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error(
        "Error fetching payment data:",
        error.response?.data || error.message
      );
    } finally {
      setIsLoading(false);
    }
  };

  //Get the Users Data
  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }
  }, [user]);

  const ViewMorePayments = async () => {
    // Update skip and take
    const newSkip = skip + 10;
    const newTake = take + 10;

    // Fetch new posts
    const payResponse = await axios.get(
      `${ApiConnectionString}/api/Payments?Skip=${newSkip}&Take=${newTake}&AppUserId=${user.id}`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (payResponse.data.length == 0) {
      setNoMorePayments(true);
    }

    // Append new posts to the existing ones
    setPayments((prevPays) => [...prevPays, ...payResponse.data]);

    // Update state variables for skip and take
    setSkip(newSkip);
    setTake(newTake);
  };
  if (isLoading) {
    return <LoadingSpinner />;
  } else {
    return (
      <div>
        <div className="lightBlueBanner mt-2 text-center">
          <p className="fw-bold mx-3 p-1">Payments Made</p>
        </div>

        <table className="custom-table">
          <thead className="blueBanner">
            <tr>
              <th>Club</th>
              <th className="hideAt450">Package</th>
              <th>Cost</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {payments.map((pay) => (
              <tr key={pay.id} onClick={() => {setSelectedPayment(pay); setOnePaymentModal(true)}}>
                <td>{pay.clubName}</td>
                <td className="hideAt450">{pay.name}</td>
                <td>£{pay.amount / 100}</td>
                {pay.created && <td>{new Date(pay.created).toLocaleString().substring(0,10)}</td>}
        
              </tr>
            ))}
          </tbody>
        </table>

        {!noMorePayments ? (
          <button className="saveChanges-button" onClick={ViewMorePayments}>
            view more
          </button>
        ) : (
          <p>No more payments.</p>
        )}

        {refundModal && (
          <RefundModal
            cancelModal={cancelModal}
            selectedPayment={selectedPayment}
            fetchData={fetchData}
          />
        )}

        {onePaymentModal && <OnePaymentModal selectedPayment={selectedPayment} cancelModal={cancelModal} refundFromOnePayment={refundFromOnePayment}/>}
      </div>
    );
  }
}
